import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Helmet } from 'react-helmet-async';
// eslint-disable-next-line no-unused-vars
import { FaPlus } from 'react-icons/fa';
import heroSolarEnergy from '../assets/hero-solar-energy.jpg';
import heroSolarEnergyMobile from '../assets/compressed/mobile/hero-solar-energy.jpg';
import heroSolarEnergyTablet from '../assets/compressed/tablet/hero-solar-energy.jpg';
import './SolarEnergy.css';
import ForumDiscussion from '../components/Forum/ForumDiscussion';
import NouvDiscModal from '../components/Forum/NouvDiscModal';
import useForumPagination from '../hooks/useForumPagination';

const SolarEnergy = () => {
    const [showModal, setShowModal] = useState(false);
    const { currentUser } = useAuth();
    const {
        discussions,
        loading,
        hasMore,
        loadMore,
        refreshDiscussions
    } = useForumPagination('solar-energy-discussions');

    return (
        <main className="solar-energy-page">
            <Helmet>
                <title>Énergie Solaire - Tech Passion</title>
                <meta name="description" content="Découvrez tout sur l'énergie solaire : panneaux photovoltaïques, technologies innovantes, stockage d'énergie et solutions pour particuliers. Guide complet pour comprendre et adopter l'énergie solaire." />
                <link rel="canonical" href="https://techpassion.fr/energie-solaire" />
                <meta name="keywords" content="énergie solaire, panneaux solaires, photovoltaïque, stockage énergie, énergie renouvelable, installation solaire, autoconsommation, transition énergétique" />
                <meta property="og:title" content="Énergie Solaire - Tech Passion" />
                <meta property="og:description" content="Explorez les solutions d'énergie solaire : technologies, innovations et conseils pour une transition vers une énergie propre et renouvelable." />
                <meta property="og:url" content="https://techpassion.fr/energie-solaire" />
                <meta property="og:type" content="website" />
            </Helmet>

            <section className="hero">
                <div className="hero-left">
                    <div className="hero-content">
                        <h1>Énergie Solaire</h1>
                        <p>Explorez les innovations en matière d'énergie solaire pour un avenir plus durable</p>
                    </div>
                </div>
                <img 
                    className="hero-image"
                    src={heroSolarEnergy}
                    srcSet={`${heroSolarEnergyMobile} 480w, ${heroSolarEnergyTablet} 768w, ${heroSolarEnergy} 1024w`}
                    sizes="(max-width: 768px) 100vw, 50vw"
                    alt="Installation de panneaux solaires avec système de stockage d'énergie intelligent et monitoring"
                    loading="lazy"
                />
            </section>

            <section className="discussions-section">
                {loading ? (
                    <div className="loading">Chargement des discussions...</div>
                ) : (
                    <div className="discussions-container">
                        {discussions.map(discussion => (
                            <ForumDiscussion
                                key={discussion.id}
                                discussion={discussion}
                                collectionName="solar-energy-discussions"
                                onReply={refreshDiscussions}
                            />
                        ))}
                    </div>
                )}

                {hasMore && (
                    <div className="load-more-container">
                        <button 
                            className="load-more-btn"
                            onClick={loadMore}
                        >
                            Voir plus
                        </button>
                    </div>
                )}
            </section>

            {currentUser && (
                <button 
                    className="new-discussion-button" 
                    title="Nouvelle discussion"
                    onClick={() => setShowModal(true)}
                >
                    <FaPlus />
                </button>
            )}

            <NouvDiscModal 
                isOpen={showModal}
                onClose={() => setShowModal(false)}
                forumId="solar-energy-discussions"
                onDiscussionUpdate={refreshDiscussions}
            />
        </main>
    );
};

export default SolarEnergy;
